import React from "react";
import { Layout, Row, Col } from "antd";
import { Link } from "react-router-dom";
import SupportCenter from "../components/SupportList";
import FullPageLayout from "../../../../shared-components/layout/FullPageLayout";
import { TranslatorNavigationTag } from "../../../../languageTranslator/LanguageTranslatorTags";

/**
 * SupportPage - Main page wrapper for Support Center
 * Follows same pattern as AllSettingsPage
 */

function SupportListPage() {
  const breadcrumbItems = [
    {
      title: (
        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
          <TranslatorNavigationTag>Support Center</TranslatorNavigationTag>
        </div>
      ),
    },
    {
      title: (
        <Link style={{ display: "flex", gap: "5px", alignItems: "center" }}>
          <TranslatorNavigationTag>Dashboard</TranslatorNavigationTag>
        </Link>
      ),
    },
  ];
  return (
    <Layout color="primary" style={{ height: "100vh" }}>
      <FullPageLayout
        name="Support Center"
        breadcrumbItems={breadcrumbItems} 
      >
        <Row gutter={[0, 16]} align="middle">
          <Col span={24}>
            <SupportCenter />
          </Col>
        </Row>
      </FullPageLayout>
    </Layout>
  );
}

export default SupportListPage;
